<template>
  <div class="grid grid-cols-4 gap-8 mb-8 sm:flex sm:flex-wrap sm:-mx-1 sm:mb-0 sm:gap-0">
    <div
      v-for="color in options"
      :key="color.code"
      class="group p-1 sm:p-0"
      :class="{ selected: isSelected(color.name), disabled: isDisabled(color.name) }"
      @click="select(color.name)"
    >
      <div
        data-analytics="Filter"
        data-label="color"
        :data-action="color.name"
        :class="{ 'border border-neutral-200': color.name === 'white' }"
        class="w-28 h-28 sm:w-12 sm:h-12 rounded-full sm:rounded-none mx-auto sm:m-1 cursor-pointer group-[.selected]:border-4 group-[.selected]:border-white group-[.selected]:ring-2 group-[.selected]:ring-black group-[.disabled]:cursor-default group-[.disabled]:opacity-30 sm:group-[.selected]:border-2 sm:group-[.selected]:border-bt-blue-500 sm:group-[.selected]:ring-0"
        :style="{ backgroundColor: color.code }"
      ></div>
      <div class="sm:hidden mt-2 text-center">
        {{ color.title }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"
import { colorFilterLimit } from "~@/store/modules/filter.module"

export default {
  name: "ColorFilter",
  props: ["options"],
  methods: {
    isSelected(color) {
      return this.selected.includes(color)
    },
    isDisabled(color) {
      return this.selected.length >= colorFilterLimit && !this.isSelected(color)
    },
    select(color) {
      !this.isSelected(color) ? this.add(color) : this.remove(color)
    },
    add(color) {
      this.mergeFilter({ colors: [...this.selected, color] })
    },
    remove(color) {
      this.mergeFilter({ colors: this.selected.filter((val) => val != color) })
    },
    ...mapActions("filter", ["mergeFilter"]),
  },
  computed: {
    ...mapState("filter", {
      selected: (state) => state.filters.colors,
    }),
  },
}
</script>
